import axios from 'axios'
import { AppSettings } from '../../configs'
import { authHeader } from '../../helpers/auth-header'
import {
    UPDATE_IR_ONE_TIME_VENDOR,
    UPDATE_IR_ONE_TIME_VENDOR_MODAL,
    GET_IR_REFERENCE,
    START_LOADING,
    STOP_LOADING
  }
    from './actionTypes';

  export function updateIR_OneTimeVendorAction(data) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_IR_ONE_TIME_VENDOR,
        data: data
      });
    }
  }

  export function updateIR_OneTimeVendorModalAction(data) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_IR_ONE_TIME_VENDOR_MODAL,
        data: data
      });
    }
  }

  export  function getIR_ReferenceAction(poNo, reference, tranNo, running, invoiceDate , vendor_code) {
      return  function (dispatch) {
          try {

            dispatch({
              type: START_LOADING
            })

            let promise=  axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/RRS/GetIR_Reference`,
                params: {
                  poNo:poNo,
                  reference:reference,
                  tranNo:tranNo,
                  running:running,
                  invoiceDate:invoiceDate,
                  vendor_code:vendor_code
                }
            })

            promise.then(response => {
              dispatch({
                type : STOP_LOADING
              })
            }
            ).catch (error=> {
              dispatch({
                type: STOP_LOADING
              })
            })
  
              return promise
          } catch (error) {
          }
      }
  }